import Card from "@/components/common/Card";

const KIND_BITS = [
  { label: "Dynamic", bit: 1 },
  { label: "Overlay", bit: 2 },
  { label: "Banner", bit: 4 },
  { label: "Static", bit: 8 },
];

export default function AudienceSummarySidebar({
  form,
  vastCount,
  vastCountLoading,
}) {
  const conditionCount =
    (form.definition.all?.length ?? 0) +
    (form.definition.any?.length ?? 0) +
    (form.definition.none?.length ?? 0);
  const kinds = KIND_BITS.filter(({ bit }) => ((form.kind ?? 15) & bit) !== 0)
    .map(({ label }) => label)
    .join(", ");

  return (
    <Card className="flex flex-col gap-4">
      <div>
        <p className="text-xs font-semibold uppercase tracking-wide text-(--text-muted)">
          Audience summary
        </p>
        <p className="mt-1 truncate text-base font-semibold text-(--text-primary)">
          {form.name || "Untitled audience"}
        </p>
      </div>

      <div className="rounded-(--radius-md) bg-(--surface-2) p-4">
        <p className="text-xs font-medium text-(--text-secondary)">
          Estimated unique devices
          <span className="ml-1 text-(--text-muted)">(last month)</span>
        </p>
        <p className="mt-2 text-2xl font-bold text-(--text-primary)">
          {vastCountLoading
            ? "Calculating…"
            : vastCount !== null
              ? vastCount.toLocaleString()
              : "—"}
        </p>
        {!vastCountLoading && vastCount === null && (
          <p className="mt-1 text-xs text-(--text-muted)">
            Add conditions to see the estimate
          </p>
        )}
      </div>

      <dl className="flex flex-col gap-2 text-sm">
        <div className="flex items-center justify-between gap-3">
          <dt className="text-(--text-secondary)">Conditions</dt>
          <dd className="font-medium text-(--text-primary)">
            {conditionCount}
          </dd>
        </div>
        <div className="flex items-center justify-between gap-3">
          <dt className="text-(--text-secondary)">CPM</dt>
          <dd className="font-medium text-(--text-primary)">
            {form.cpm === "" || form.cpm === null ? "—" : form.cpm}
          </dd>
        </div>
        <div className="flex items-center justify-between gap-3">
          <dt className="text-(--text-secondary)">Inventory</dt>
          <dd className="text-right font-medium text-(--text-primary)">
            {kinds || "—"}
          </dd>
        </div>
      </dl>
    </Card>
  );
}
